import { render, staticRenderFns } from "./squarecopy.vue?vue&type=template&id=9e7b3de8&"
import script from "./squarecopy.vue?vue&type=script&lang=js&"
export * from "./squarecopy.vue?vue&type=script&lang=js&"
import style0 from "./squarecopy.vue?vue&type=style&index=0&id=9e7b3de8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports